module.exports = __webpack_public_path__ + "img/Work on the most important projects.739707ff.gif";